import React, { createContext, useState, useContext } from 'react'

interface SectionInViewContextType {
  visibleSection: string
  setVisibleSection: Function
}

const SectionInViewContext = createContext<SectionInViewContextType>({
  visibleSection: '',
  setVisibleSection: () => {},
})

const SectionInViewContextProvider = ({ children }: any) => {
  const [visibleSection, setVisibleSection] = useState('')

  return (
    <SectionInViewContext.Provider
      value={{ visibleSection, setVisibleSection }}
    >
      {children}
    </SectionInViewContext.Provider>
  )
}

const useSectionInViewContext = () => {
  const context = useContext(SectionInViewContext)

  if (context === undefined) {
    throw new Error(
      'useSectionInViewContext must be used within a SectionInViewContextProvider',
    )
  }

  return context
}

export { SectionInViewContextProvider, useSectionInViewContext }
